import { createFileRoute } from "@tanstack/react-router";

import NewPaymentMethod from "@/shared/components/payment-methods/NewPaymentMethod";

export const Route = createFileRoute("/_authenticated/settings/payment-methods/new/")({
  component: NewPaymentMethod,
  context: () => ({ permissions: "settings.payment-methods" }),
});
